import { PayloadAction } from '@reduxjs/toolkit';
import { PendingRedecorateActionPayload } from '../ConfigurableGrid/ConfigurableGrid.types';

/** This action is for refreshing between different frontend components
 * that are capable of rendering on screen at the same time,
 * where we need to keep the data consistent between the two,
 * such as when the Editable Style Pane is open at the same time as an Editable Grid
 */
export const REQUEST_EXTERNAL_DATA_REFRESH = 'REQUEST_EXTERNAL_DATA_REFRESH';
export function requestExternalDataRefresh(
  requestRefresh: PendingRedecorateActionPayload,
): PayloadAction<PendingRedecorateActionPayload> {
  return {
    type: REQUEST_EXTERNAL_DATA_REFRESH,
    payload: requestRefresh,
  };
}
